import styled from 'styled-components';

import { popupContentText } from '../../common/colorConstants';
import { lowHeightScreens, mediumScreens, smallScreens } from '../../common/fontElements';
import { PopupImage } from '../Popups.styles';

export const StepContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 20px;
`;

export const StepRight = styled.div`
  flex-basis: 82%;
  align-items: center;
`;

export const StepLeft = styled.div`
  flex-basis: 18%;
  align-items: flex-start;
  color: #abb1b6;
  font-size: 10.9px;
  display: flex;
  align-items: center;
`;

export const DropdownArea = styled.div`
  margin: 0px 10% 0px;
  padding: 30px 0px 60px;
`;

export const ProgressSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const ProgressBar = styled.div`
  width: 99px;
  height: 8px;
  border-radius: 4px;
  background-color: #e0e6eb;
  overflow: hidden;
`;

export const Bar = styled.div`
  background-color: #4fd77b;
  transition: 1s;
  width: ${(props) => props.width}%;
  height: 8px;
  border-radius: 4px 0px 0px 4px;
`;

export const ProgressText = styled.div`
  color: #444444;
  font-size: 11px;
  margin-bottom: 15px;
`;

export const TooltipText = styled.p`
  font-size: 10.5px;
  margin-top: 20px;
  text-decoration: underline;
  font-family: lato, sans-serif;
  cursor: pointer;
`;

export const SectionTitle = styled.p`
  font-size: 13.9px;
  font-weight: bold;
  color: #444444;
  margin-bottom: 30px;
`;

export const PopupContent = styled.div`
  color: ${popupContentText};
  // something is injecting inline style width: auto
  // TODO find root cause
  width: 320px !important;
  word-wrap: break-word;
  min-height: 430px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  @media screen and (max-width: ${mediumScreens}) {
    width: 330px !important;
  }

  @media screen and (max-height: ${lowHeightScreens}), screen and (max-width: ${smallScreens}) {
    width: 310px !important;
  }
`;

export const ThankYouSection = styled(PopupContent)`
  justify-content: center;
  align-items: center;
`;

export const Image = styled(PopupImage)`
  margin-bottom: 15px;
`;

export const Flag = styled.img`
  width: 20px;
  margin: 0px auto 15px;
  display: block;
`;

export const FlagText = styled.p`
  background-color: white;
  position: relative;
  overflow: hidden;
  display: block;
  margin: 0px 30px;
`;

export const FlagContainer = styled.div`
  text-align: center;
  transition: opacity 300ms ease-in-out;
`;

export const ContentWrapper = styled.div`
  padding: 20px 30px 30px;

  @media screen and (max-width: ${mediumScreens}) {
    padding: 20px 25px 25px;
  }

  @media screen and (max-height: ${lowHeightScreens}), screen and (max-width: ${smallScreens}) {
    padding: 20px;
  }
`;
